import React, { useState } from "react";
import { Modal, Form } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import formatName from "../utils/formatName";

const AVATAR_COLORS = ["#3656A5", "#08734F", "#8A4B08"];
const SEARCH_MIN_LEARNERS = 8;

function ModuleAccessSummary({ count = 0, names = "" }) {
  const parsedNames = Array.isArray(names)
    ? names
    : String(names || "")
        .split("||")
        .map((name) => formatName(name))
        .filter(Boolean);
  const total = Math.max(Number(count || 0), parsedNames.length);
  const visibleNames = parsedNames.slice(0, 3);
  const remaining = Math.max(total - visibleNames.length, 0);

  const [show, setShow] = useState(false);
  const [search, setSearch] = useState("");

  const openModal = (event) => {
    // The summary sits inside a clickable card, so keep the click to itself.
    event.stopPropagation();
    setSearch("");
    setShow(true);
  };

  const query = search.trim().toLowerCase();
  const filteredNames = query
    ? parsedNames.filter((name) => name.toLowerCase().includes(query))
    : parsedNames;

  return (
    <>
      <button
        type="button"
        className="module-access"
        onClick={openModal}
        title="View learners with access"
        aria-label={`${total} ${total === 1 ? "learner has" : "learners have"} access. View list`}
      >
        <div className="module-access__avatars" aria-hidden="true">
          {visibleNames.map((name, index) => (
            <span
              className="module-access__avatar"
              style={{ backgroundColor: AVATAR_COLORS[index % AVATAR_COLORS.length] }}
              key={`${name}-${index}`}
            >
              {name.charAt(0).toUpperCase()}
            </span>
          ))}
          {remaining > 0 && <span className="module-access__avatar module-access__avatar--more">+{remaining}</span>}
          {total === 0 && <span className="module-access__avatar module-access__avatar--empty">0</span>}
        </div>
        <div className="module-access__copy">
          <strong>{total}</strong>
          <span>{total === 1 ? "learner has access" : "learners have access"}</span>
        </div>
      </button>

      <Modal
        show={show}
        onHide={() => setShow(false)}
        centered
        scrollable
        dialogClassName="module-access-modal"
        style={{ fontFamily: "Manrope-Regular" }}
        onClick={(event) => event.stopPropagation()}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Learners with access
            <span className="module-access-modal__count">{total}</span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {parsedNames.length > SEARCH_MIN_LEARNERS && (
            <div className="module-access-modal__search">
              <FaSearch size={13} />
              <Form.Control
                type="text"
                placeholder="Search learner"
                value={search}
                onChange={(event) => setSearch(event.target.value)}
              />
            </div>
          )}

          {filteredNames.length > 0 ? (
            <ul className="module-access-modal__list">
              {filteredNames.map((name, index) => (
                <li key={`${name}-${index}`}>
                  <span
                    className="module-access-modal__avatar"
                    style={{
                      backgroundColor:
                        AVATAR_COLORS[parsedNames.indexOf(name) % AVATAR_COLORS.length],
                    }}
                  >
                    {name.charAt(0).toUpperCase()}
                  </span>
                  <span className="module-access-modal__name">{name}</span>
                </li>
              ))}
            </ul>
          ) : (
            <p className="module-access-modal__empty">
              {parsedNames.length === 0
                ? "No learners assigned yet."
                : "No learners match your search."}
            </p>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ModuleAccessSummary;
